/**
 * Help webpack determine where to load chunks, etc in an external environment
 */

if (typeof window !== 'undefined') {
  let publicPath = window.document.currentScript;

  if (!publicPath) {
    publicPath =
      window.performance &&
      typeof window.performance.getEntries === 'function' &&
      window.performance
        .getEntries()
        .filter(entry => entry.initiatorType === 'script')
        .slice(-1)[0].name;
  } else {
    publicPath = publicPath.src;
  }

  if (publicPath) {
    publicPath = publicPath.match(/(.+\/)[^/]+\.js(\?.*)?$/);
    // if async chunk of package complied in other packages, don't overwrite it.
    if(__webpack_public_path__ === "") { // eslint-disable-line
      __webpack_public_path__ = publicPath[1]; // eslint-disable-line
    }
  }
}

// Indicate to webpack that this file can be concatenated
export default null;
